(function () {
  'use strict';

  if (window.FabAppTrack) return;

  function context(overrides) {
    overrides = overrides || {};

    try {
      var platform = window.FabPlatform || {};
      var dataset = (document.body && document.body.dataset) || {};

      return {
        app_surface: overrides.app_surface != null ? overrides.app_surface : overrides.surface || null,
        app_pitch: overrides.app_pitch != null ? overrides.app_pitch : overrides.pitch || null,
        device_os: platform.os || 'other',
        is_in_app_browser: !!platform.isInAppBrowser,
        page_type: dataset.pageType || null,
        page_slug: dataset.pageSlug || null
      };
    } catch (e) {
      return {
        app_surface: null,
        app_pitch: null,
        device_os: 'other',
        is_in_app_browser: false,
        page_type: null,
        page_slug: null
      };
    }
  }

  window.FabAppTrack = {
    context: context
  };
})();
